"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnumOption = void 0;
function isEnumOption(option) {
    return Array.isArray(option.values);
}
exports.isEnumOption = isEnumOption;
